import generateProductTitle from './generateProductTitle'
import generateProductUrl from './generateProductUrl'

const generateItemDetails = data => {
  const { product, price, notes } = data

  const title = generateProductTitle(data)

  const productUrl = generateProductUrl(data)

  return {
    sku: product?.sku,
    title,
    productUrl,
    price: price?.regular,
    productImageUrl: product?.image?.url,
    brand: product?.brand?.name,
    productNotes: notes,
  }
}

export default generateItemDetails
